import React from 'react';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import { SnackbarProvider } from 'notistack';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { SnackbarProviderProps } from 'notistack';

const useStyles = makeStyles((theme) => ({
  contentRoot: {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
    whiteSpace: 'pre-wrap',
  },
}));

const AppSnackbarProvider = ({ children, ...props }: SnackbarProviderProps) => {
  const classes = useStyles();
  const notistackRef = React.useRef();

  return (
    <SnackbarProvider
      hideIconVariant
      preventDuplicate
      {...props}
      classes={{
        ...props.classes,
        contentRoot: clsx(
          props.classes?.contentRoot,
          classes.contentRoot,
          'text-break-all',
        ),
      }}
      ref={notistackRef}
      action={(key) => (
        <IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={() => notistackRef.current?.closeSnackbar?.(key)}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      )}
    >
      {children}
    </SnackbarProvider>
  );
};

export default AppSnackbarProvider;
